// モーダルを閉じた後 再度開いた時に、stateの値を見てチェックを入れる
export const isDefaultChecked = (
  formState: Record<string, { url: string }>,
  value: string | number,
): boolean => Object.keys(formState).includes(String(value));
